import { useLocale } from '../i18n/LocaleProvider'
import type { ReactNode } from 'react'
import Navbar from './Navbar'
import CTAStrip from './CTAStrip'
import Footer from './Footer'
import TickerBand from './TickerBand'
import './CorporatePageLayout.css'

interface CorporatePageLayoutProps {
  title: string
  titleLang?: string
  compactTitleOnMobile?: boolean
  japaneseSubtitle: ReactNode
  englishSubtitle: ReactNode
  children: ReactNode
}

export default function CorporatePageLayout({
  title,
  titleLang,
  compactTitleOnMobile = false,
  japaneseSubtitle,
  englishSubtitle,
  children,
}: CorporatePageLayoutProps) {
  const { locale } = useLocale()
  return (
    <>
      <Navbar heroSelector=".cp-header" />

      <div className="cp-page">
        <header className="cp-header">
          <div className="cp-header-inner container">
            <h1 lang={titleLang} className={`cp-header-title${compactTitleOnMobile ? ' cp-header-title--compact-mobile' : ''}`}>
              {title}
            </h1>
            <div className="cp-header-copy">
              <p className="cp-header-sub" lang={locale}>{locale === 'ja' ? japaneseSubtitle : englishSubtitle}</p>
            </div>
          </div>
        </header>

        <TickerBand />
        {children}
      </div>

      <CTAStrip />
      <Footer />
    </>
  )
}
